import { jsx as _jsx } from "react/jsx-runtime";
import { TransferPaymentsContextProvider } from "./TransferPaymentContext";
const TransferPayments = (props) => {
    return (_jsx("div", { className: "sub-wrap", children: _jsx(TransferPaymentsContextProvider, { transferType: props.transferType, children: props.children }) }));
};
export default TransferPayments;
